export default "__VITE_ASSET__DxnAHdt0__"